"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var youtube_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/youtube/youtube");
exports.service = new youtube_1.YoutubeService({
    withCredentials: true,
    xsrfHeaderName: null,
    xsrfCookieName: null,
});
//# sourceMappingURL=youtube.js.map